<div class="modal right" id="offerDetail" tabindex="-1" role="dialog" aria-labelledby="offerDetailLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
                    <h4 id="offerDetailLabel">Offer Detail</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-6 mt-2">
									<div class="print-modal-customer">
										<div class="panel mb-10">
											<p>
												<strong>Offer ID </strong>
												<span>
													{{ offer.unique }}
												</span>
											</p>
											<p>
												<strong>Date</strong>
												<span>
													{{ offer.date | amDateFormat:'MM/DD/YYYY' }}
												</span>
											</p>
											<p>
												<strong>Duration </strong>
												<span>
													{{ offer.duration }} 
												</span>
											</p>
											<p>
												<strong>Vehicle </strong>
												<span>
													{{ offer.wehicle }}
												</span>
											</p>
											<p>
												<strong>Receiver </strong>
												<span>
													{{ offer.receiver ? 'All' : 'Selected Drivers' }}
												</span>
											</p>
											<div ng-if="!offer.receiver">
												<p ng-repeat="item in offer.receivers">
													{{ item.full_name }}
												</p>
											</div>
											<!-- <p>
												<strong>Status </strong>
												<span>
													{{ offer.status }} 
												</span>
											</p> -->
										</div>
									</div>
								</div>
								<div class="col-md-6 mt-2">
									<div class="print-modal-customer">
										<div class="panel mb-10">
											<p>
												<strong>Station </strong>
												<span>
													{{ offer.station.code }}
												</span>
											</p>
											<p>
												<strong>Delivery time</strong>
												<span>
													{{ offer.date + ' ' + offer.start_time | amDateFormat:'hh:mm A' }} - {{ offer.date + ' ' + offer.end_time | amDateFormat:'hh:mm A' }}
												</span>
											</p>
											<p>
												<strong>Price $ / HR </strong>
												<span>
													{{ offer.price }} / {{ offer.price / (offer.duration / 60) | number:2 }}
												</span>
											</p>
											<p>
												<strong>Pcs </strong>
												<span>
													{{ offer.worker_count }}
												</span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<a href="#" 
										class="hod-button blue ml10" 
										ng-click="editOffer(offer)">
										Edit Offer
									</a>
									<a href="#" 
										class="hod-button blue ml10" 
										ng-click="sendToApp(offer.id)">
										Send to App
									</a>
								</div>
							</div>
							<div class="row mt-4">
								<div class="col-md-12">
									<div class="panel-heading">
										<span class="panel-title"> Applications</span>
										<a href="#" class="pull-right" data-toggle="modal" data-target="#newOfferWorker">
											<i class="fa fa-plus" style="font-size: 24px;"></i>
										</a>
										<hr>
									</div>
									<div class="table-responsive" ng-if="offer.workers.length > 0">
										<table class="table table-hover tc-checkbox-1 fs13">
											<thead class="p20">
												<tr class="bg-light">
													<th></th>
													<th>Full Name</th>
													<th>Email</th>
													<th>Phone Number</th>
													<th>#</th>
												</tr>
											</thead>
											<tbody>
												<tr class="text-left" ng-repeat="item in offer.workers | filter: data.term | orderBy:sortType:sortReverse ">
													<td class="clickable-row text-center w100" ng-click="getWorkerDetails(item.worker.id)">
														<img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.worker.profile_photo }}" class="img-responsive text-center img-circle" width="36px" height="36px" style="width:36px;  height:36px;" alt="">
													</td>
													<td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">{{ item.worker.user.email}}</td>
													<td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">{{ item.worker.user.full_name}}</td>
													<td class="clickable-row" ng-click="getWorkerDetails(item.worker.id)">{{ item.worker.phone_number }}</td>
													<td class="clickable-row">
														<a href="#" class="btn btn-danger" ng-click="removeWorker(offer, item.worker.id)">Remove</a>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="text-center mt50" ng-if="offer.workers.length == 0">
										<h3 style="font-size: 48px;font-weight: 800;">Application not found</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
